export const pageHeading = "Our Turmeric";
export const headerImg = "./images/inner-header-bg.png";
